import { render, staticRenderFns } from "./PrincipalCompanyWidget.vue?vue&type=template&id=f28724c6"
import script from "./PrincipalCompanyWidget.vue?vue&type=script&lang=js"
export * from "./PrincipalCompanyWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports